var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaginaAfdrukkenIcoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pagina_afdrukken_Icoon",
    "data-name": "Pagina afdrukken Icoon",
    transform: "translate(-925 -708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    transform: "translate(925 708)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-print",
    "data-name": "Icon material-print",
    d: "M17.168,8.667H5.5a2.5,2.5,0,0,0-2.5,2.5v5H6.334V19.5h10V16.168h3.334v-5A2.5,2.5,0,0,0,17.168,8.667Zm-2.5,9.168H8V13.668h6.668ZM17.168,12A.833.833,0,1,1,18,11.168.836.836,0,0,1,17.168,12Zm-.833-7.5h-10V7.834h10Z",
    transform: "translate(928.469 710.998)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginaAfdrukkenIcoon);
export default __webpack_public_path__ + "static/media/Pagina-afdrukken-Icoon.2759a760.svg";
export { ForwardRef as ReactComponent };